import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import { alpha, useTheme } from "@mui/material/styles";

export default function ClientPortalUnavailablePage({ message, companyName }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "grid",
        placeItems: "center",
        px: 2,
        py: 4,
        bgcolor: (t) =>
          t.palette.mode === "dark" ? "#0b0b0f" : alpha(t.palette.primary.main, 0.04),
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 480, textAlign: "center" }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: 2,
            mx: "auto",
            mb: 2,
            display: "grid",
            placeItems: "center",
            bgcolor: alpha(theme.palette.primary.main, 0.12),
            color: "primary.main",
          }}
        >
          <SupportAgentOutlinedIcon />
        </Box>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Portal do Cliente
        </Typography>
        {companyName ? (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {companyName}
          </Typography>
        ) : null}
        <Alert severity="info" sx={{ textAlign: "left" }}>
          {message ||
            "O portal ainda não está disponível para sua empresa. Peça ao suporte da empresa para habilitar o acesso."}
        </Alert>
      </Box>
    </Box>
  );
}
